<template>
  <v-app id="inspire">
    <v-card tile class="screen-card">
      <v-container class="login-form">
        <v-row dense>
          <v-spacer></v-spacer>
          <v-col>
            <v-img class="logo" :src="$vuetify.breakpoint.width > 1100 ? textLogo : textLogoCenter"></v-img>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-form>
          <v-row dense>
            <v-col>
              <v-text-field
                color="primary"
                v-model="email"
                autocomplete="username"
                label="E-mail de acesso"
                type="text"
                name="usuario"
                dense
                solo
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                color="primary"
                v-model="password"
                autocomplete="current-password"
                label="Senha"
                type="password"
                name="senha"
                dense
                solo
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                class="action-button"
                :loading="loading"
                color="primary"
                type="submit"
                dark
                @click.prevent="handleSubmit"
              >Entrar</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                class="action-button"
                @click="handleRecoverDialog"
                color="warning"
                dark
              >Esqueci a Senha</v-btn>
            </v-col>
          </v-row>
          <v-row class="text">
              <v-col class="d-flex justify-center align-center">
                <v-divider class="flex-grow-1"></v-divider>
                <span class="mx-2">OU</span>
                <v-divider class="flex-grow-1"></v-divider>
              </v-col>
          </v-row>
          <v-row>
            <v-col>
            <v-btn
              class="action-button"
              color="secondary"
              dark
              @click.prevent="handleMicrosoftSSO"
            >
              <v-icon left>mdi-microsoft</v-icon>
              Entrar com conta da g2l
            </v-btn>
         </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-dialog v-model="dialogRecover" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Recuperar Senha</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Digite seu Email"
                    type="email"
                    v-model="emailrecover"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="handleSendRecover">Enviar Requisição</v-btn>
            <v-btn color="error" dark @click="dialogRecover = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <v-snackbar v-model="snackbar">{{ snackMessage }}</v-snackbar>
  </v-app>
</template>

<script>
import textLogo from "../../src/assets/images/text-logo-center.svg";
import textLogoCenter from "../../src/assets/images/text-logo.svg";

import { PublicClientApplication } from '@azure/msal-browser';

export default {
  data: () => ({
    snackbar: false,
    snackMessage: ``,
    loading: false,
    textLogo,
    textLogoCenter,
    email: "",
    password: "",
    dialogRecover: false,
    token: "",
    emailrecover: ""
  }),
  methods: {
    async handleSubmit() {
      this.loading = true;

      await this.$store.dispatch(`User/login`, {
        account: this.token,
        email: this.email,
        password: this.password
      });
      const hasError = this.$store.getters[`User/error`]

      if (!hasError) {
        this.$router.push(`/`).catch(err => err && console.error(err));
      } else {
        this.snackbar = true;
        this.snackMessage = hasError;
      }

      this.loading = false;
    },

    async handleSendRecover() {
      if (!/^(.+)@([a-z0-9_-]+\.)+([a-z]+)$/.test(this.emailrecover)) {
        this.snackbar = true;
        this.snackMessage = `Email inválido. Tente novamente.`;
        return;
      }

      const response = await this.$store.dispatch(`api`, {
        entity: `recovery`,
        action: `recover`,
        payload: {
          type: "user",
          identification: this.emailrecover
        }
      });

      if (response && response.status === 200) {
        this.snackbar = true;
        this.snackMessage = `Um link para redefinição de senha foi enviado para o seu email.`;
        this.dialogRecover = false;
      } else {
        this.snackbar = true;
        this.snackMessage = `Não foi possível enviar o email. Verifique o endereço digitado e tente novamente.`;
      }
    },
    handleRecoverDialog() {
      this.dialogRecover = !this.dialogRecover;
    },
    async handleMicrosoftSSO() {
      await this.$msalInstance
        .loginPopup({})
        .then(() => {
          const myAccounts = this.$msalInstance.getAllAccounts();
          this.account = myAccounts[0];
          this.token = this.account.idToken;
          this.$emitter.emit('login', this.account);
          this.handleSubmit();
         
        })
        .catch(error => {
          console.error(`error during authentication: ${error}`);
        });
    },
  },
  created() {
    console.log(this.$store.state.sso.msalConfig);
    this.$msalInstance = new PublicClientApplication(
      this.$store.state.sso.msalConfig,
    );
    localStorage.removeItem(`token`)
  }
};
</script>
<style scoped>
  .screen-card {
    width: 100vw;
    height: 100vh;
    background-image: url('../assets/images/login-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .login-form {
    position: absolute;
    bottom: calc(50% - 15em);
    right: 100px;
    width: 30%;
  }
  .logo {
    margin-bottom: 20px;
    width: 100%;
  }
  .action-button {
    width: 100%;
  }

@media(max-width: 430px) {
  .screen-card {
    display: flex;
    justify-content: center;
  }
}

@media only screen and (max-width: 1100px){

  .logo{
    margin-bottom: 20px;
  }

  .login-form {
    position: static;
    width: 100%;
  }

}

</style>
